import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: ({ size = 10, page = 0 } = {}) => `/api/admin/getUsers/${size}/${page}`,
      providesTags: ['User'],
    }),

    addUser: builder.mutation({
      query: (formData) => ({
        url: '/api/admin/createUser',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['User'],
    }),

  }),
});

export const {
  useGetUsersQuery,
  useAddUserMutation,
} = userApi;
